/* eslint-disable */
import * as Yup from 'yup';
import React, { useState, useEffect, useRef } from 'react';
import { Container, Card, FormControl, InputLabel, Checkbox, FormHelperText } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Box, Button } from '@material-ui/core';
import SearchNotFound from '../../../SearchNotFound';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import Chip from '@material-ui/core/Chip';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import TablePagination from '@mui/material/TablePagination';
import Page from '../../../Page';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import PropTypes from 'prop-types'
import { useTheme } from '@mui/material/styles';
import services from '../Services';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import { makeStyles } from '@material-ui/styles';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import CreatePDF from './CreatePDF';
import ReactToPrint from "react-to-print";
import xlsx from 'json-as-xlsx';
import Select from '@material-ui/core/Select';
import ClearIcon from '@mui/icons-material/Clear';

var screenCode = "PURCHASINGHISTORYREPORT"

function TablePaginationActions(props) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;

    const handleFirstPageButtonClick = (event) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <Box sx={{ flexShrink: 0, ml: 2.5 }}>
            <IconButton
                onClick={handleFirstPageButtonClick}
                disabled={page === 0}
                aria-label="first page"
            >
                {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
            </IconButton>
            <IconButton
                onClick={handleBackButtonClick}
                disabled={page === 0}
                aria-label="previous page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
            <IconButton
                onClick={handleLastPageButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="last page"
            >
                {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
            </IconButton>
        </Box>
    );
}

TablePaginationActions.propTypes = {
    count: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

export default function PurchasingHistoryReport(props) {

    const navigate = useNavigate();
    const componentRef = useRef();
    const [headCells, SetHeadCells] = useState([]);
    const [order, setOrder] = React.useState('asc');
    const [orderBy, setOrderBy] = React.useState('cropForecastdate');
    const [page, setPage] = React.useState(0);

    const [rowsPerPage, setRowsPerPage] = React.useState(5);
    const [factoryNameArray, setFactoryNameArray] = useState([]);
    const useStyles = makeStyles((theme) => ({
        root: {
            width: '100%'
        },
        paper: {
            width: '100%',
            marginBottom: theme.spacing(2)
        },
        table: {
            minWidth: 750
        },
        visuallyHidden: {
            border: 0,
            clip: 'rect(0 0 0 0)',
            height: 1,
            margin: -1,
            overflow: 'hidden',
            padding: 0,
            position: 'absolute',
            top: 20,
            width: 1
        }
    }));
    const classes = useStyles();
    function EnhancedTableHead(props) {
        const { order, orderBy, onRequestSort } = props;
        const createSortHandler = (property) => (event) => {
            onRequestSort(event, property);
        };
        return (
            <TableHead>
                <TableRow>
                    {headCells.map((headCell) => (
                        <TableCell
                            key={headCell.id}
                            align={headCell.align}
                            padding={headCell.disablePadding ? 'none' : 'normal'}
                            sortDirection={orderBy === headCell.id ? order : false}
                        >
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id ? (
                                    <span className={useStyles.visuallyHidden}>
                                    </span>
                                ) : null}
                            </TableSortLabel>
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        )
    }

    EnhancedTableHead.propTypes = {
        classes: PropTypes.object.isRequired,
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.oneOf(['asc', 'desc']).isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired
    };

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const onKeyDown = (e) => {
        e.preventDefault();
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [group, setGroup] = useState([]);
    const [factory, setFactory] = useState([]);
    const [product, setProduct] = useState([]);
    const [productcatogery, setProductcatogery] = useState([]);
    const [fromDate, setFromDate] = useState(new Date());
    const [toDate, settoDate] = useState(new Date());
    const [cropAvailability, setCropAvailability] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [selectedCategoryOptions, setSelectedCategoryOptions] = useState([]);
    const [selectedProductOptions, setSelectedProductOptions] = useState([]);
    const [totalFcc, setTotalFcc] = useState(0);
    const [formData, setFormData] = useState({
        groupID: 0,
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: new Date(fromDate).toISOString(),
        toDate: new Date(toDate).toISOString(),
        isActive: true
    });

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });

    const productAvailabilitySchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.array().required('Please select at least one Fresh collection center').min(1, 'Please select at least one Fresh collection center'),
        productCategoryID: Yup.array().min(1, 'Please Select Product Category').required('Product Category Required'),
        productID: Yup.array().min(1, 'Please Select Product').required('Product Required'),
        fromDate: Yup.date().min(1).min(1, 'Please Select Start Date').required('Start Date required')
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: '',
        operationEntityID: '',
        productCategoryID: '',
        productID: '',
        fromDate: '',
        toDate: ''
    });
    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions,
            fromDate: formData.fromDate,
            toDate: formData.toDate,
            isActive: formData.isActive
        },
        validationSchema: productAvailabilitySchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm());
        },
    });
    const [totalValues, setTotalValues] = useState({
        totalOfTotalOrder: 0,
        totalOfTotalRecivedQty: 0,
        totalOfTotalShortSupply: 0,

    });

    useEffect(() => {
        getPermissions()
    }, []);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWPURCHASINGHISTORYREPORT');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
        })
        trackPromise(GetAllGroups());
        trackPromise(GetProductCategoties());
    }

    async function SubmitForm() {
        setCropAvailability([])
        SetHeadCells([])
        setTotalValues({
            totalOfTotalOrder: 0,
            totalOfTotalRecivedQty: 0,
            totalOfTotalShortSupply: 0,
        })
        setPage(0);
        let newRes = await services.GetPurchasingHistoryReportDetails(
            selectedOptions.map(x => x).join(',').toString(),
            selectedProductOptions.map(x => x).join(',').toString(),
            (fromDate).toISOString(),
            (toDate).toISOString(),
        );

        setOrder('asc');
        setOrderBy('cropForecastdate');
        var result = [];
        var resultOne = [];
        var headCellsOne = [];
        newRes.forEach(y => {
            y.details.forEach(x => {
                var factory = x.factoryName;
                var oderDate = x.orderDate ? new Date(x.orderDate).toLocaleDateString() : '';

                var duplicateDate = result.find(y => y.skuCode === x.skuCode && y.orderDate === oderDate);
                if (duplicateDate) {
                    duplicateDate.orderDate = oderDate;
                    duplicateDate[factory] = duplicateDate[factory] == undefined ? 0 + x.quantity : duplicateDate[factory] + x.quantity;
                    duplicateDate.skuCode = x.skuCode;
                    duplicateDate.skuDescription = x.skuDescription;
                    duplicateDate.totalRecivedQty = duplicateDate.totalRecivedQty + x.receivedQty;
                    duplicateDate.totalOrder = duplicateDate.totalOrder + x.quantity;
                    duplicateDate.totalShortSupply = duplicateDate.totalShortSupply + (x.quantity - x.receivedQty);
                }
                else {
                    result.push({
                        orderDate: oderDate,
                        [factory]: x.quantity,
                        skuCode: x.skuCode,
                        skuDescription: x.skuDescription,
                        totalRecivedQty: x.receivedQty,
                        totalOrder: x.quantity,
                        totalShortSupply: x.quantity - x.receivedQty
                    });
                }
            });
        });

        result.forEach(x => {
            x.fillRate = x.totalOrder == 0 ? 0 : (x.totalRecivedQty / x.totalOrder) * 100
        })

        newRes.forEach(y => {
            y.details.forEach(x => {
                var duplicateDate = resultOne.find(y => y.factory === x.factoryName);
                if (duplicateDate) {
                    duplicateDate.factory = x.factoryName
                }
                else {
                    resultOne.push({
                        factory: x.factoryName,
                    });
                }
            });
        });
        resultOne.sort((a, b) => a.factory > b.factory ? 1 : -1);
        headCellsOne.push(
            {
                id: 'orderDate',
                numeric: true,
                disablePadding: false,
                label: 'Order Date',
                align: "center"
            },
            {
                id: 'skuCode',
                numeric: false,
                disablePadding: false,
                label: 'SKU Code',
                align: "center"
            },
            {
                id: 'skuDescription',
                numeric: true,
                disablePadding: false,
                label: 'SKU Description',
                align: "center"
            })

        resultOne.forEach(x => {
            headCellsOne.push({
                id: x.factory,
                numeric: true,
                disablePadding: false,
                label: x.factory,
                align: "right"
            })
        })

        headCellsOne.push({
            id: 'totalOrder',
            numeric: true,
            disablePadding: false,
            label: 'Total Order',
            align: "right"
        },
            {
                id: 'totalRecivedQty',
                numeric: true,
                disablePadding: false,
                label: 'Received Qty',
                align: "right"
            },
            {
                id: 'totalShortSupply',
                numeric: true,
                disablePadding: false,
                label: 'Short Supply',
                align: "right"
            },
            {
                id: 'fillRate',
                numeric: true,
                disablePadding: false,
                label: 'Fill Rate (%)',
                align: "right"
            })

        result.sort((a, b) => {
            const dateA = new Date(a.orderDate);
            const dateB = new Date(b.orderDate);
            return dateB - dateA;
        });

        setFactoryNameArray(resultOne);
        setTotalFcc(2 + resultOne.length);
        setCropAvailability(result);
        SetHeadCells(headCellsOne)
        createDataForExcel(result);
        getSelectedDropdownValuesForReport();
    }

    const { errors, setValues, touched, handleSubmit, getFieldProps, values } = formik;

    async function clearAll() {
        if (!permissionList.isFactoryFilterEnabled) {
            setCropAvailability([]);
            setSelectedCategoryOptions([])
            setFromDate(new Date());
            setSelectedProductOptions([]);
            setSelectedOptions([]);
        } else {
            setSelectedCategoryOptions([]);
            setFromDate(new Date());
            setSelectedOptions([]);
            setSelectedProductOptions([]);
        }
    }

    useEffect(() => {
        setPage(0);
        trackPromise(GetProductCategoties());
        trackPromise(GetAllGroups());
    }, []);

    useEffect(() => {
        setPage(0);
        trackPromise(GetProductDetails());
    }, [selectedCategoryOptions]);

    useEffect(() => {
        if (cropAvailability.length != 0) {
            calculateTotalQty()
        }
    }, [cropAvailability]);

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
        setSelectedCategoryOptions([])
        setSelectedProductOptions([])
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
        setSelectedProductOptions([])
    }, [formik.values.productCategoryID]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [formik.values.productID]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [fromDate]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [toDate]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [selectedOptions]);

    useEffect(() => {
        setPage(0);
        setValues({
            ...values,
            operationEntityID: selectedOptions,
            productCategoryID: selectedCategoryOptions,
            productID: selectedProductOptions
        })
    }, [selectedOptions, selectedCategoryOptions, selectedProductOptions]);

    useEffect(() => {
        setPage(0);
        const factoryValue = parseInt(TokenDecoder.getGroupFactoryToken().factory);
        const selectedOptions = [factoryValue];
        setSelectedOptions(selectedOptions)
    }, [factory]);

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [selectedCategoryOptions])

    useEffect(() => {
        setPage(0);
        setCropAvailability([]);
    }, [selectedProductOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length > 0 && selectedCategoryOptions.length > 0) {
            trackPromise(GetProductDetails())
        }
    }, [selectedCategoryOptions, selectedOptions])

    useEffect(() => {
        setPage(0);
        if (selectedOptions.length == 0) {
            setProductcatogery([])
        } else {
            trackPromise(GetProductCategoties())
        }
    }, [selectedOptions])


    async function GetProductCategoties() {
        var res = await services.GetProductCategoties()
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productCategoryName, value: res[i].productCategoryID })
            }
            setProductcatogery(newOptionArray);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetProductsByFactoryIDProductcatogeryID(
            selectedOptions.map(x => x).join(','),
            selectedCategoryOptions.map(x => x).join(",")
        )
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].productName, value: res[i].productID })
            }
            setProduct(newOptionArray);
        }
    }

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetVCCFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            var newOptionArray = [];
            for (var i = 0; i < res.length; i++) {
                newOptionArray.push({ label: res[i].factoryName, value: res[i].factoryID })
            }
            setFactory(newOptionArray);
        }
    }

    async function createDataForExcel(array) {
        var res = [];
        if (array != null) {
            array.forEach(x => { });
        }
        return res;
    }

    async function createFile(array) {
        var file = await createDataForExcel(cropAvailability);

        var settings = {
            sheetName: 'Purchasing History Report',
            fileName: 'Purchasing History Report',
            writeOptions: {}
        };

        let headCellsTwo = [];
        var res = [];

        headCellsTwo.push(
            { label: 'Order Date', value: 'orderDate' },
            { label: 'SKU Code', value: 'skuCode' },
            { label: 'SKU Description', value: 'skuDescription' });

        factoryNameArray.forEach(x => {
            const label = x.factory;
            const value = x.factory == undefined ? ' - ' : x.factory;
            headCellsTwo.push({ label, value });
        });

        headCellsTwo.push(
            { label: 'Total Order', value: 'totalOrder' },
            { label: 'Received Qty', value: 'totalRecivedQty' },
            { label: 'Short Supply', value: 'totalShortSupply' },
            { label: 'Fill Rate (%)', value: 'fillRate' }
        );


        const formattedCropAvailability = cropAvailability.map(item => {
            let formattedItem = {
                ...item,
                totalOrder: item.totalOrder ? item.totalOrder.toFixed(2) : '-',
                totalRecivedQty: item.totalRecivedQty ? item.totalRecivedQty.toFixed(2) : '-',
                totalShortSupply: item.totalShortSupply ? item.totalShortSupply.toFixed(2) : '-',
                fillRate: item.fillRate ? item.fillRate.toFixed(2) : '-'
            };

            factoryNameArray.forEach(column => {
                const value = item[column.factory];
                formattedItem[column.factory] = value === undefined || value == 0 ? '-' : parseFloat(value).toFixed(2);
            });

            return formattedItem;
        });


        const totalValues = {
            totalOrder: cropAvailability.reduce((acc, curr) => acc + (curr.totalOrder || 0), 0),
            totalRecivedQty: cropAvailability.reduce((acc, curr) => acc + (curr.totalRecivedQty || 0), 0),
            totalShortSupply: cropAvailability.reduce((acc, curr) => acc + (curr.totalShortSupply || 0), 0),
        };


        factoryNameArray.forEach(column => {
            totalValues[column.factory] = cropAvailability.reduce((acc, curr) => {
                return acc + (curr[column.factory] || 0);
            }, 0);
        });

        const emptyRow = {
            skuCode: '',
            skuDescription: '',
        };

        factoryNameArray.forEach(column => {
            emptyRow[column.factory] = '';
        });

        emptyRow.totalOrder = '';
        emptyRow.totalRecivedQty = '';
        emptyRow.totalShortSupply = '';
        emptyRow.fillRate = '';

        formattedCropAvailability.push(emptyRow);

        const totalRow = {
            skuCode: 'Total',
            skuDescription: '',
            totalOrder: totalValues.totalOrder ? totalValues.totalOrder.toFixed(2) : '-',
            totalRecivedQty: totalValues.totalRecivedQty ? totalValues.totalRecivedQty.toFixed(2) : '-',
            totalShortSupply: totalValues.totalShortSupply ? totalValues.totalShortSupply.toFixed(2) : '-',
        };

        factoryNameArray.forEach(column => {
            const value = totalValues[column.factory];
            totalRow[column.factory] = value === undefined || value == 0 ? '-' : parseFloat(value).toFixed(2);
        });

        formattedCropAvailability.push(totalRow);

        let dataA = [
            {
                sheet: 'Purchasing History Report',
                columns: headCellsTwo,
                content: formattedCropAvailability
            }
        ];
        xlsx(dataA, settings);
    }

    const handleSelectChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedOptions(selectedOptions.length === factory.length ? [] : factory.map((option) => option.value));
        } else {
            setSelectedOptions(value);
        }
    };

    const handleSelectCategoryChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedCategoryOptions(selectedCategoryOptions.length === productcatogery.length ? [] : productcatogery.map((option) => option.value));
        } else {
            setSelectedCategoryOptions(value);
        }
    };

    const handleSelectProductChange = (event) => {
        const value = event.target.value;
        if (value.includes("")) {
            setSelectedProductOptions(selectedProductOptions.length === product.length ? [] : product.map((option) => option.value));
        } else {
            setSelectedProductOptions(value);
        }
    };

    const handleClearSelection = () => {
        setSelectedOptions([]);
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearCategorySelection = () => {
        setSelectedCategoryOptions([]);
        setSelectedProductOptions([]);
    };

    const handleClearProductSelection = () => {
        setSelectedProductOptions([]);
    };

    function getSelectedDropdownValuesForReport() {
        const facName = [];
        selectedOptions.forEach(x => {
            const fildered = (factory.find(y => x == y.value)) == undefined ? '' : factory.find(y => x == y.value).label
            facName.push(fildered)
        });

        const categoryName = [];
        selectedCategoryOptions.forEach(x => {
            const filterCategory = productcatogery.find(y => x == y.value).label
            categoryName.push(filterCategory);
        })

        const productName = [];
        selectedProductOptions.forEach(x => {
            const filterProduct = product.find(y => x == y.value).label
            productName.push(filterProduct);
        })

        let groups = group.find(x => x.groupID == formik.values.groupID)

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: groups.groupName,
            operationEntityID: facName.length == 0 ? 'All Fresh Collection Centers' : facName.filter(x => x !== '').join(','),
            productCategoryID: categoryName.map(x => x).join(','),
            productID: productName.map(x => x).join(',')
        });
    }

    const renderSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = factory.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = factory.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderCategorySelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = productcatogery.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = productcatogery.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };

    const renderProductSelectedValue = (selected) => {
        if (selected.length === 0) {
            return '';
        } else if (selected.length === 1) {
            const option = product.find((entity) => entity.value === selected[0]);
            return option ? <Chip label={option.label} /> : '';
        } else {
            const selectedChips = selected.map((value, index) => {
                if (index === 0) {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip label={option.label} /> : null;
                } else {
                    const option = product.find((entity) => entity.value === value);
                    return option ? <Chip key={index} label={option.label} /> : null;
                }
            });
            const moreCount = selected.length - 1;
            return (
                <div>
                    {selectedChips[0]} + {moreCount} more
                </div>
            );
        }
    };
    function calculateTotalQty() {
        const factoryTotals = {};

        factoryNameArray.forEach((factory) => {
            factoryTotals[factory.factory] = 0;
        });

        cropAvailability.forEach((factory) => {
            factoryNameArray.forEach((column) => {
                if (factory[column.factory] !== undefined) {
                    factoryTotals[column.factory] += factory[column.factory];
                }
            });
        });

        const totalOfTotalOrder = cropAvailability.reduce((accumulator, current) => accumulator + current.totalOrder, 0);
        const totalOfTotalRecivedQty = cropAvailability.reduce((accumulator, current) => accumulator + current.totalRecivedQty, 0);
        const totalOfTotalShortSupply = cropAvailability.reduce((accumulator, current) => accumulator + current.totalShortSupply, 0);

        setTotalValues({
            ...totalValues,
            ...factoryTotals,
            totalOfTotalOrder: totalOfTotalOrder,
            totalOfTotalRecivedQty: totalOfTotalRecivedQty,
            totalOfTotalShortSupply: totalOfTotalShortSupply,
        })
    };

    return (
        <>
            <LoadingComponent />
            <Page title="Purchasing History Report |  FAPS">
                <Container>
                    <CommonPageHeader
                        path={"/purchasingHistoryReport"}
                        btname="Add"
                        pageName="Purchasing History Report"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover
                        />
                        <Form
                            autoComplete="off"
                            disabled={!(formik.isValid && formik.dirty)}
                            noValidate
                            onSubmit={handleSubmit}
                        >
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            style: {
                                                height: "48px",
                                                width: "100%"
                                            },
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}>Select Group</MenuItem>
                                        {group.map((option) => (
                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <FormControl fullWidth error={Boolean(touched.operationEntityID && errors.operationEntityID)}>
                                        <InputLabel id="multi-select-label">Fresh Collection Center *</InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedOptions}
                                            onChange={handleSelectChange}
                                            label="Fresh Collection Center "
                                            disabled={!permissionList.isFactoryFilterEnabled}
                                            renderValue={(selected) => renderSelectedValue(selected)}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedOptions.length === factory.length} color="primary" />
                                                All Fresh Collection Center
                                            </MenuItem>
                                            {factory.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.operationEntityID && errors.operationEntityID && (
                                            <FormHelperText>{errors.operationEntityID}</FormHelperText>
                                        )}
                                        {selectedOptions.length > 0 && (
                                            <IconButton onClick={handleClearSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                {!permissionList.isFactoryFilterEnabled ? null :
                                                    <ClearIcon />}
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <FormControl fullWidth error={Boolean(touched.productCategoryID && errors.productCategoryID)}>
                                        <InputLabel id="multi-select-label">Product Category * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedCategoryOptions}
                                            onChange={handleSelectCategoryChange}
                                            label="Product Category "
                                            disabled={selectedOptions.length == 0}
                                            renderValue={(selected) => renderCategorySelectedValue(selected)}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedCategoryOptions.length === productcatogery.length} color="primary" />
                                                All Product Category
                                            </MenuItem>
                                            {productcatogery.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedCategoryOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productCategoryID && errors.productCategoryID && (
                                            <FormHelperText>{errors.productCategoryID}</FormHelperText>
                                        )}
                                        {selectedCategoryOptions.length > 0 && (
                                            <IconButton onClick={handleClearCategorySelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                </Stack>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <FormControl fullWidth error={Boolean(touched.productID && errors.productID)}>
                                        <InputLabel id="multi-select-label">Product * </InputLabel>
                                        <Select
                                            className="custom-select"
                                            labelId="multi-select-label"
                                            id="multi-select"
                                            multiple
                                            size="small"
                                            value={selectedProductOptions}
                                            onChange={handleSelectProductChange}
                                            label="Product"
                                            disabled={selectedCategoryOptions.length == 0}
                                            renderValue={(selected) => renderProductSelectedValue(selected)}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        >
                                            <MenuItem key={0} value={''}>
                                                <Checkbox checked={selectedProductOptions.length === product.length} color="primary" />
                                                All Products
                                            </MenuItem>
                                            {product.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                    <Checkbox checked={selectedProductOptions.indexOf(option.value) > -1} color="primary" />
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                        {touched.productID && errors.productID && (
                                            <FormHelperText>{errors.productID}</FormHelperText>
                                        )}
                                        {selectedProductOptions.length > 0 && (
                                            <IconButton onClick={handleClearProductSelection} style={{ position: 'absolute', top: '50%', right: '24px', transform: 'translateY(-50%)' }}>
                                                <ClearIcon />
                                            </IconButton>
                                        )}
                                    </FormControl>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select Start Date *"
                                            value={fromDate}
                                            onChange={(newValue) => {
                                                setFromDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('fromDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.fromDate && errors.fromDate)}
                                                helperText={touched.fromDate && errors.fromDate}
                                                {...params} />}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                                        <DatePicker
                                            label="Select End Date *"
                                            value={toDate}
                                            onChange={(newValue) => {
                                                settoDate(newValue);
                                            }}
                                            maxDate={new Date()}
                                            renderInput={(params) => <TextField
                                                fullWidth
                                                size="small"
                                                {...getFieldProps('toDate')}
                                                onKeyDown={onKeyDown}
                                                error={Boolean(touched.toDate && errors.toDate)}
                                                helperText={touched.toDate && errors.toDate}
                                                {...params} />}
                                            InputProps={{
                                                style: {
                                                    height: "48px",
                                                    width: "100%"
                                                },
                                            }}
                                        />
                                    </LocalizationProvider>
                                </Stack>
                                <br />
                                <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                    <Button
                                        type="button"
                                        variant="outlined"
                                        color='error'
                                        onClick={() => clearAll()}
                                    > Clear</Button>
                                    <Button
                                        type="submit"
                                        color='secondary'
                                        variant="outlined"
                                    >Search</Button>
                                </Stack>
                            </Stack>
                            <br />
                            <>
                                {cropAvailability.length != 0 ? (
                                    <>
                                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                            <Card style={{ justifycontent: 'center', width: '85rem' }} >
                                                <TableContainer>
                                                    <Table
                                                        aria-labelledby="tableTitle"
                                                        aria-label="enhanced table"
                                                    >
                                                        <EnhancedTableHead
                                                            classes={classes}
                                                            order={order}
                                                            orderBy={orderBy}
                                                            onRequestSort={handleRequestSort}
                                                            rowCount={cropAvailability.length}
                                                        />
                                                        <TableBody>
                                                            {stableSort(cropAvailability, getComparator(order, orderBy))
                                                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                .map((factory, index) => {
                                                                    const labelId = `enhanced-table-checkbox-${index}`;
                                                                    return (
                                                                        <TableRow key={index}>
                                                                            <TableCell component="th" id={labelId} scope="row" align='center'>
                                                                                {factory.orderDate}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='center'>
                                                                                {factory.skuCode}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='center'>
                                                                                {factory.skuDescription}
                                                                            </TableCell>
                                                                            {factoryNameArray.map((column) => {
                                                                                const value = factory[column.factory];
                                                                                return (
                                                                                    <TableCell id={labelId} scope="row" align={column.tableCellAlign == 1 ? 'right' : column.tableCellAlign == 2 ? 'right' : 'right'}>
                                                                                        {value == undefined ? '-' : column.numeric == true ? parseFloat(value).toFixed(2) : parseFloat(value).toFixed(2)}
                                                                                    </TableCell>
                                                                                );
                                                                            })}
                                                                            <TableCell component="th" id={labelId} scope="row" align='right'>
                                                                                {factory.totalOrder > 0 ? parseFloat(factory.totalOrder).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='right'>
                                                                                {factory.totalRecivedQty > 0 ? parseFloat(factory.totalRecivedQty).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='right'>
                                                                                {factory.totalShortSupply > 0 ? parseFloat(factory.totalShortSupply).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                            <TableCell component="th" id={labelId} scope="row" align='right'>
                                                                                {factory.fillRate > 0 ? parseFloat(factory.fillRate).toFixed(2) : '-'}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    );
                                                                })}
                                                        </TableBody>
                                                        <TableRow>
                                                            <TableCell align="center" colSpan={3} style={{ fontWeight: "bold" }}>Total</TableCell>
                                                            {factoryNameArray.map((column) => {
                                                                return (
                                                                    <TableCell key={column.factory} align="right" style={{ fontWeight: "bold" }}>
                                                                        {totalValues[column.factory] === 0 ? '-' : parseFloat(totalValues[column.factory]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                                    </TableCell>
                                                                );
                                                            })}
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                {(totalValues.totalOfTotalOrder === "-" || totalValues.totalOfTotalOrder === 0)
                                                                    ? '-'
                                                                    : parseFloat(totalValues.totalOfTotalOrder).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                {(totalValues.totalOfTotalRecivedQty === "-" || totalValues.totalOfTotalRecivedQty === 0)
                                                                    ? '-'
                                                                    : parseFloat(totalValues.totalOfTotalRecivedQty).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}>
                                                                {totalValues.totalOfTotalShortSupply === "-" || totalValues.totalOfTotalShortSupply === 0
                                                                    ? '-'
                                                                    : parseFloat(totalValues.totalOfTotalShortSupply).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </TableCell>
                                                            <TableCell align="right" style={{ fontWeight: "bold" }}></TableCell>
                                                        </TableRow>

                                                    </Table>
                                                </TableContainer>
                                                <TablePagination
                                                    rowsPerPageOptions={[5, 10, 25]}
                                                    component="div"
                                                    count={cropAvailability.length}
                                                    rowsPerPage={rowsPerPage}
                                                    page={page}
                                                    onPageChange={handleChangePage}
                                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                                />
                                            </Card>
                                        </Stack>
                                    </>
                                ) : <SearchNotFound searchQuery="Purchasing History Report" />}</>
                        </Form>
                    </FormikProvider>
                    {cropAvailability.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <div>&nbsp;</div>
                            <style>
                                {`
                                 @page  {
                                            size: A4 landscape; 
                                            margin: 20mm;
                                        }
                               `}
                            </style>
                            <ReactToPrint
                                documentTitle={"Purchasing History report"}
                                trigger={() => <Button
                                    color="primary"
                                    id="btnRecord"
                                    type="submit"
                                    variant="contained"
                                    style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    className={classes.colorCancel}
                                >
                                    PDF
                                </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    productList={cropAvailability}
                                    searchData={selectedSearchValues}
                                    factoryNameArray={factoryNameArray}
                                    EnhancedTableHead={EnhancedTableHead}
                                    order={order}
                                    orderBy={orderBy}
                                    handleRequestSort={handleRequestSort}
                                    onRequestSort={handleRequestSort}
                                    totalValues={totalValues}
                                />
                            </div>
                        </Box> : null}
                </Container>
            </Page>
        </>
    );
}

